/* global google */
import React from "react";
import { withScriptjs } from "react-google-maps";
import PropTypes from "prop-types";

const withMaps = (WrappedComponent) => {
  const geocode = (address) =>
    new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (status !== "OK") return reject(status);
        const { location } = results[0].geometry;
        const { lat, lng } = location.toJSON();

        return resolve([lat, lng]);
      });
    });

  const ScriptWrapper = withScriptjs(({ googleMapURL, loadingElement, ...props }) => (
    <WrappedComponent {...props} geocode={geocode} />
  ));

  ScriptWrapper.propTypes = {
    googleMapUrl: PropTypes.string,
    loadingElement: PropTypes.node,
  };

  ScriptWrapper.defaultProps = {
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}`,
    loadingElement: <div style={{ height: "100%" }} />,
  };

  return ScriptWrapper;
};

export default withMaps;
